export default __webpack_public_path__ + "static/media/maxiPadBottom.ef999858.png";